import cancelIcon from "../../../assets/images/cancel-btn.svg";

/** Shared confirmation popup used by template removal and child selection. */
export function PopupConfirmationModal({
  isOpen,
  message,
  isConfirming = false,
  confirmLabel = "Yes",
  cancelLabel = "No",
  onClose,
  onConfirm,
}) {
  if (!isOpen) return null;

  return (
    <div className="popup holidayPopup">
      <div className="popup-content removePop">
        <button
          aria-label="Close confirmation"
          className="cancelBtn"
          onClick={onClose}
          type="button"
        >
          <img src={cancelIcon} alt="" />
        </button>
        <div className="addNursePopup">
          <h2 className="removeHdn">{message}</h2>
          <div className="removeNurse">
            <div className="nurseBtns">
              <button
                className="yesBtn"
                disabled={isConfirming}
                onClick={onConfirm}
                type="button"
              >
                {isConfirming ? "Please wait..." : confirmLabel}
              </button>
              <button className="noBtn" onClick={onClose} type="button">
                {cancelLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
